(function ($) {
	let defaults = {
		debug: false
	};

	let options;
	let debugInited = false;

	const ARROW_POINTER_OFFSETS = {
		sw: {
			left: { x: -5, y: -10 },
			right: { x: 51, y: -29 }
		},
		s: {
			left: { x: -15, y: -7 },
			right: { x: 23, y: -25 }
		},
		se: {
			left: { x: -61, y: -34 },
			right: { x: 5, y: -0 }
		},
		nw: {
			left: { x: -4, y: 0 },
			right: { x: 51, y: 23 }
		},
		n: {
			left: { x: -14, y: 6 },
			right: { x: 18, y: 6 }
		},
		ne: {
			left: { x: -63, y: 26 },
			right: { x: 5, y: -6 }
		}
	}

	$.fn.arrowCallout = function(opts) {
		options = $.extend({}, defaults, opts);
		let $callouts = $(this);

		$callouts.each(function() {
			init(this);
			position(this);
		});

		$(window).on('resize', debounce(function() {
			$callouts.each(function() {
				position(this);
			})
		}, 250));

		// Debug can also be enabled by setting a query string parameter, ?debug=true
		if (location.search.indexOf('debug=true') > 0) {
			options.debug = true;
		}

		if (options.debug && !debugInited) {
			initDebug();
		}
	};

	/**
	 * @internal
	 * Helper function that makes positioning callouts easier
	 * How to use:
	 * 1. Make sure your callouts have data-container and data-target attributes
	 * 2. Click on a callout
	 * 3. Click on the target image where you want the callout arrow to point
	 * 4. Check the console for data-x and data-y numbers
	 */
	function initDebug() {
		$('.js-arrow-callout').on('click', function() {
			let $callout = $(this);
			let $container = $callout.closest( $(this).data('container') );

			$callout.css('pointer-events', 'none');

			if ($container.length) {
				let $targetImage = $container.find( $(this).data('target') );

				if ($targetImage.length) {
					$targetImage.off('click').on('click', function(e) {
						let $this = $(this);
						let xPct = (e.offsetX / $this.width() * 100);
						let yPct = (e.offsetY / $this.height() * 100);

						$callout.data('x', xPct);
						$callout.data('y', yPct);
						position( $callout.get(0) );

						console.log('data-x="' + xPct + '" data-y="' + yPct + '"');
						$callout.css('pointer-events', 'all');
					});
				}
			}
		});

		debugInited = true;
		$(window).trigger('resize');
	}

	/**
	 * Sets up the markup and content of the arrow callout
	 * @internal
	 */
	function init(el) {
		var $this = $(el);
		var arrowDir = $this.data('arrowDir') || 'left';
		var acCompass = $this.data('compass') || 'sw';
		var acArrowDir = (arrowDir === "right") ? "" : "arrow-callout__arrow--flipped";
		let randomID = 'callout' + Math.floor(Math.random() * new Date().getTime());
		$this.attr('data-calloutid', randomID);

		// Empty out the contents of the callout and replace the existing markup with our desired markup
		var content = $this.text().trim();
		$this.empty();

		//inject our arrow callout code
		if (!arrowDir || arrowDir == "right") {
			$('<div class="arrow-callout__text">' + content + '</div>' +
				'<div class="arrow-callout__arrow arrow-callout__arrow--' + acCompass + '"></div>').appendTo($this);
		} else {
			$('<div class="arrow-callout__arrow ' + acArrowDir + ' arrow-callout__arrow--' + acCompass + '"></div>' +
				'<div class="arrow-callout__text">' + content + '</div>').appendTo($this);
		}

		// Add extra classes if this callout faces right or down - this helps with scaling
		if (arrowDir === 'right') {
			$this.addClass('arrow-callout--right');
		} if (['sw', 's', 'se'].indexOf(acCompass) >= 0) {
			$this.addClass('arrow-callout--bottom');
		}


		$(window).on('load', function(){
			$(window).trigger('resize');
		});
	}

	/**
	 * Builds and positions the arrow callout
	 * @internal
	 * @param (HTMLElement) el
	 */
	function position(el) {
		var $this = $(el),
			container = $this.data('container'),
			targetImage = $this.data('target'),
			calloutID = $this.data('calloutid'),
			dontWrap = $this.data('dontWrap') ? true : false;

		//set default values
		var acX = $this.data('x') || 0;
		var acLargeX = $this.data('largeX') || acX || 0;
		var acY = $this.data('y') || 0;
		var acLargeY = $this.data('largeY') || acY || 0;
		var arrowDir = $this.data('arrowDir') || 'left';
		var acSize = $this.data('size') || 'default';
		var acCompass = $this.data('compass') || 'sw';
		var fontSize;
		var maxSize;

		let isLargeScreen = window.innerWidth >= 1200;

		// Unset the transform of this object
		el.style.transform = '';

		// Wrap target image and move callouts there
		if (container) {
			let $container = $this.closest(container);
			let $targetImage = $container.find(targetImage);
			let $imageWrapper;

			if ($container.length && !dontWrap) {
				$imageWrapper = $targetImage.closest('.arrow-callout-wrapper');

				if (!$targetImage.closest('.arrow-callout-wrapper').length) {
					$targetImage.wrap('<div class="arrow-callout-wrapper" />');
					$imageWrapper = $targetImage.closest('.arrow-callout-wrapper');
				}

				$this.appendTo($imageWrapper);
			} else {
				$imageWrapper = $container;
			}

			if (options.debug) {
				$imageWrapper.addClass('v-styleguide__highlight');
				$this.addClass('v-styleguide__highlight');
			}

			if (options.debug) {
				// Add/update debug targets
				$imageWrapper.find('.arrow-callout-target[data-calloutID="' + calloutID + '"]').remove();
				$('<div class="arrow-callout-target" data-calloutid="' + calloutID + '">').css({
					left: (isLargeScreen ? acLargeX : acX) + '%',
					top: acY + '%',
					zIndex: 51
				}).appendTo($imageWrapper);
			}
		}

		//change default font sizes based on size argument
		switch (acSize) {
			case "large":
				fontSize = "56";
				maxSize = "28";
				break;
			case "small":
				fontSize = "32";
				maxSize = "16";
				break;
			default:
				fontSize = "38";
				maxSize = "18";
		}

		//check parents width and height
		var parentWidth = $this.parent().outerWidth();
		var parentHeight = $this.parent().outerHeight();

		//get percentage to add onto left and top positions
		var calloutWidthPercentage = ($this.width() / parentWidth) * 100;
		var calloutHeightPercentage = ($this.height() / parentHeight) * 100;

		//set positioning
		var posX = (arrowDir === 'right') ? (isLargeScreen ? acLargeX : acX) - calloutWidthPercentage : (isLargeScreen ? acLargeX : acX);
		var posY = (isLargeScreen ? acLargeY : acY);
		let offsetX = ARROW_POINTER_OFFSETS[acCompass][arrowDir].x;
		let offsetY = ARROW_POINTER_OFFSETS[acCompass][arrowDir].y;
		if (['sw', 's', 'se'].indexOf(acCompass) > -1) {
			posY -= calloutHeightPercentage;
		}

		//setup css
		//font-size -- if were over the maxSize set it to the maxSize or else scale proportionally.
		let transform = getComputedStyle(el).transform;
		$this.css({
			opacity: 1,
			zIndex: 51,
			left: posX + "%",
			top: posY + "%",
			transform: '' + transform + ' translate(' + offsetX + 'px, ' + offsetY + 'px)'
			// fontSize: ((parentWidth * (fontSize / 100)) / 10) < maxSize ? ((parentWidth * (fontSize / 100)) / 10 + "px") : maxSize + "px"
		});

		//if the percent is less than 0 or greater than 100% we need to
		// include some margin on the parent to make room for it.
		if (container) {
			let $container = $this.closest(container);
			let containerHeight = $container.outerHeight();
			let calloutTop = el.offsetTop;
			let calloutBottom = el.offsetTop + el.offsetHeight;

			if (posX < 0) {
				$container.css('margin-top', $this.outerHeight());
			}

			if (calloutBottom > containerHeight) {
				$container.css('margin-bottom', $this.outerHeight());
			} else {
				$container.css('margin-bottom', '');
			}
		}

		$this.removeClass('state-hidden');

		//setup resize handler to help us shrink text accordingly
		/*$(window).off('resize.arrowCallout').on('resize.arrowCallout', debounce(function () {
			parentWidth = $this.parent().outerWidth();
			parentHeight = $this.parent().outerHeight();
			var overflowsRight = ($this.outerWidth() + ($this.position().left - 20)) > parentWidth;
			var overflowsLeft = acX < 0;
			/!*$this.css({
				fontSize: ((parentWidth * (fontSize / 100)) / 10) < maxSize ? ((parentWidth * (fontSize / 100)) / 10 + "px") : maxSize + "px"
			});*!/

			//if the percent is less than 0 or greater than 100% we need to
			// include some margin on the parent to make room for it.
			if (posX < 0) {
				acContainer.css('margin-top', $this.outerHeight());
			} else if (posY > 100) {
				acContainer.css('margin-bottom', $this.outerHeight());
			}

			//checkOverflows(overflowsLeft, overflowsRight, isSmallScreen, $this);
		}, 10));*/


		/*function checkOverflows(overflowsLeft, overflowsRight, isSmallScreen, $this) {
			if(overflowsRight && isSmallScreen) {
				//$this.addClass('arrow-callout__sticky-right');
			} else {
				//$this.removeClass('arrow-callout__sticky-right');
			}

			if(overflowsLeft && isSmallScreen) {
				//$this.addClass('arrow-callout__sticky-left');
			} else {
				//$this.removeClass('arrow-callout__sticky-left');
			}
		};*/

		// $(window).trigger('resize');
	}

	//setup the debounce function for resize handlers
	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

}(jQuery));



//////////////////
// WEBPACK FOOTER
// ./js/lib/jquery.arrowCallout.js
// module id = 79
// module chunks = 0